import flatpickr from "flatpickr";
import { German as LocaleDE } from "flatpickr/dist/l10n/de.js"
import { French as LocaleFR } from "flatpickr/dist/l10n/fr.js"
import { Italian as LocaleIT } from "flatpickr/dist/l10n/it.js"
import { english as LocaleEN } from "flatpickr/dist/l10n/default.js"

function onlyNumbers(str) {
    return /^[0-9]+$/.test(str);
  }

function validateTreatmentNumber(event){
    const inputField = event.target;
    const invalidTreatmentNumber = document.getElementById('invalid-treatment-number');
    let tNumber = inputField.value.trim();
    
    // Cut off anything after slash
    slash_pos = tNumber.indexOf("/");
    if(slash_pos != -1){
        tNumber = tNumber.slice(0,slash_pos)
        tNumber = tNumber.trim()
    }

    // block 0 
    if (tNumber === "0") {
        inputField.value = "";
        return;
    }

    if(tNumber === "") {
        inputField.value = "";
        if (invalidTreatmentNumber) {
            invalidTreatmentNumber.style.display = "none";
        }
        return;
    }

    inputField.value = tNumber

    // validation
    const iSinvalid = tNumber === "0" || tNumber.length < 7 ||  tNumber.length > 8 || !onlyNumbers(tNumber)
    
    if (invalidTreatmentNumber) {
        invalidTreatmentNumber.style.display = iSinvalid ? "block" : "none";
    }

}

let localeToUse = LocaleEN;

if(document.body.attributes["language"].value == "de"){
    localeToUse = LocaleDE
}
else if(document.body.attributes["language"].value == "fr"){
    localeToUse = LocaleFR
}
else if(document.body.attributes["language"].value == "it"){
    localeToUse = LocaleIT
}

flatpickr("#invoiceDateWrapper", {dateFormat: "d.m.Y", weekNumbers: "true", wrap: true, locale: localeToUse});

flatpickr("#dateFirstRateWrapper", {
    minDate: new Date().fp_incr(7),
    dateFormat: "d.m.Y", 
    weekNumbers: "true",
    wrap: true,
    locale: localeToUse,

    disable: [
        // 0 = Sonntag, 6 = Samstag
        function(date) {
            return date.getDay() === 0 || date.getDay() === 6;
        }
    ]

});

// to prevent Uncaught TypeError: Cannot set properties of null (setting 'onchange')
function registerTreatmentNumberEvents() {
    const inputTreatmentNumber = document.getElementById('treatment-number');

    // only proceed if the element exists
    if (inputTreatmentNumber) {
        inputTreatmentNumber.oninput = validateTreatmentNumber;

        // validate when user leaves the field
        inputTreatmentNumber.addEventListener('focusout', function(event) {
            validateTreatmentNumber(event);
        });
    }
    const form = document.getElementById('form');
}

// Intial load (full page), before accessing elements
document.addEventListener("DOMContentLoaded", registerTreatmentNumberEvents);

// After Turbo frame/page loads (e.g after form submission)
document.addEventListener("turbo:frame-load", function (event) {
    if (event.target.id === "calculate-rates-form") {
        registerTreatmentNumberEvents();
    }
});